module.exports = __webpack_public_path__ + "img/ordF6.18b9316d.jpg";